
import { useChatbotBaseMutations } from "./mutations/useChatbotBaseMutations";
import { useThemeMutations } from "./mutations/useThemeMutations";
import { useQuestionMutations } from "./mutations/useQuestionMutations";
import { useTriggerRuleMutations } from "./mutations/useTriggerRuleMutations";

export const useChatbotMutations = (id: string | undefined) => {
  const { updateChatbot, deleteChatbot } = useChatbotBaseMutations(id);
  const { updateTheme } = useThemeMutations(id);
  const { addQuestion, updateQuestion, deleteQuestion, updateQuestionsOrder } = useQuestionMutations(id);
  const { addTriggerRule, updateTriggerRule, deleteTriggerRule } = useTriggerRuleMutations(id);

  return {
    updateChatbot,
    deleteChatbot,
    updateTheme,
    addQuestion,
    updateQuestion,
    deleteQuestion,
    updateQuestionsOrder,
    addTriggerRule,
    updateTriggerRule,
    deleteTriggerRule,
  };
};
